import { Survey } from "survey-react-ui";
import type { SurveyModel } from "survey-core";
import { Completed } from "./Completed";

export class SurveyForm extends Survey {
  renderCompleted(): JSX.Element {
    return <Completed survey={this.survey as SurveyModel} />;
  }
}
